'use strict';

/**
 * Client for the Budskap Api
 */
customerZone.service('BudskapClient', ['$http', '$q', '$filter', '$timeout', '$log', 'config', 'RestClientBase',
    'Session', function($http, $q, $filter, $timeout, $log, config, RestClientBase, Session){

        var base = config.budskapApi ? new RestClientBase(config.budskapApi.endpoint) : undefined;
        var self = this;

        var httpConfig = {
            headers: {
                'Accept-Language': config.language ? config.language.substr(0, 2) : 'nl'
            }
        };

        var mapNotificationsToModel = function(payload){
            return {
                id: payload['pk'],
                body: payload['body'],
                context: payload['context'],
                level: payload['level'],
                priority: payload['priority']
            };
        };

        /*  @param: string (Optional) context of the notification
            @return a promise to an array of both anonymous notifications and
            for the currently authenticated user ones, with the default context and the given one (if any).
         */
        self.getNotifications = function(context){
            /* There are currently two types of budskap responses in the wild - one wrapped in an object, and one
               of a direct array.  We're supporting both at the moment.  In the near future budskap will standardize
               on the array form and we can get rid of this.
             */

            if (!config.budskapApi || !config.budskapApi.endpoint) return $q.when([]);
            return $http.get(base.url('notifications/' + (context ? ('?context='+context) : '')), httpConfig)
                .then(base.unwrapResponse, base.unwrapError)
                .then(function(data){
                    if (Array.isArray(data)) return data.map(mapNotificationsToModel);
                    return data.notifications.map(mapNotificationsToModel);
                });
        };

        self.sendAddressUpdatedEvent = function(){
            if (!config.budskapApi || !config.budskapApi.endpoint) return;
            httpConfig['headers']['Authorization'] = 'Bearer '+ Session.token;
            return $http.post(base.url('customer-events/'), {'kind': 'address_updated'}, httpConfig)
                .then(base.unwrapResponse, base.unwrapError);
        };

        self.getNotificationSettings = function(){
            return $http.get(base.url('customer-flags/'), httpConfig)
                .then(base.unwrapResponse, base.unwrapError)
                .then(function(response){
                    return response.map(function(entry){
                        return {name: entry.name, channels: {mail: !!entry.mail || !!entry.opt_in}};
                    });
                });
        };

        self.setNotificationSettings = function(values){
            var data = values.map(function(entry){
                return {'name': entry.name, 'mail': !!entry.channels.mail, 'opt_in': !!entry.channels.mail};
            });
            return $http.post(base.url('customer-flags/'), data, httpConfig)
                .then(base.unwrapResponse, base.unwrapError);
        };

        self.getBestTariffs = function(subscriptionId) {
            return $http.get(base.url('best-tariff/{}', subscriptionId), httpConfig)
                .then(base.unwrapResponse, base.unwrapError)
                .then(function(payload) {
                    return {
                        peakUsage: payload.best_tariff_jim_peak_cost,
                        suggestionType: payload.best_tariff_jim_suggestion_type,
                        currentProductId: payload.best_tariff_jim_current_priceplan_id,
                        suggestedProductId: payload.best_tariff_jim_suggested_priceplan_id
                    };
                });
        };
    }]);
